import styled from 'styled-components';
import { TEXT_FIELD_CSS } from './TextField.styles';

export const StyledTextarea = styled.textarea`
    ${TEXT_FIELD_CSS}
    height: auto;
`;